require("./bootstrap");

import { createApp } from "vue";

import { BootstrapVue3, BToastPlugin } from "bootstrap-vue-3";
import VueMask from "@devindex/vue-mask";
import { LoadingPlugin } from "vue-loading-overlay";
import { store } from "./store/index";
import router from "./router/index.js";
import moment from "moment";

import LoaderComponent from "./components/LoaderComponent.vue";
import Banner from "./components/Banner.vue";
import ContentHeader from "./components/ContentHeader.vue";
import SideBarNav from "./components/SideBarNav.vue";
import Register from "./components/Register.vue";
import Login from "./components/Login.vue";
import Datepicker from "vue3-datepicker";
import DirectToDealerFinalSignature from "./components/DirectToDealerFinalSignature.vue";
import SearchBySerial from "./components/SearchBySerial.vue";

// import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";

const app = createApp({});

window.url = "/";

var Emitter = require("tiny-emitter");
window.emitter = new Emitter();
// app.config.globalProperties.emitter = new Emitter();

app.config.globalProperties.$filters = {
    moneyFormat(value) {
        return Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(
            value
        );
    },
    percentFormat(value) {
        return parseFloat(value).toFixed(2);
    },
    dateFormat(value) {
        return moment(String(value)).format("MM/DD/YYYY");
    },
    dateFormat2(value) {
        return moment(String(value)).format("YYYY-MM-DD");
    },
    dateTimeFormat(value) {
        return moment(String(value)).format("MM/DD/YYYY - hh:mm A");
    },
    moneyFormatWhole(value) {
        return Intl.NumberFormat("en-US", { minimumFractionDigits: 0 }).format(
            value
        );
    },
};

app.component("loader-component", LoaderComponent);
app.component("banner", Banner);
app.component("content-header", ContentHeader);
app.component("side-bar-nav", SideBarNav);
app.component("register", Register);
app.component("login", Login);
app.component("datepicker", Datepicker);
app.component("final-signature", DirectToDealerFinalSignature);
app.component("search-by-serial", SearchBySerial);

app.use(router);
app.use(BootstrapVue3);
app.use(VueMask);
app.use(BToastPlugin);
app.use(LoadingPlugin);
app.use(store);

app.mount("#app");
